// @flow

import React from "react";

import { curry, isEmpty, isNil } from "ramda";

import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
  ID_OPCAO_DEFLATOR_NENHUM,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSelecionados,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";

import SelecaoAjusteDePreco from "../configuracoes/ajusteDePreco/SelecaoAjusteDePreco";
import SelecaoDeflacao from "../configuracoes/deflacao/SelecaoDeflacao";

export const criaFuncaoValidacaoSeriesComAjusteEDeflator = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjusteEDeflator = curry(
  (
    processarUltimaNegociacao,
    state: State,
    medidas: Array<MedidaSelecionada>
  ): Array<MedidaSelecionada> => {
    const ajustesPreco = getAjustesPrecoSelecionados(state) || [];
    const edicaoMedida = getEdicaoMedida(state);
    const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

    return medidas.flatMap(medida =>
      ajustesPreco.map(ajuste => {
        const ultimaNegociacao =
          processarUltimaNegociacao && edicaoMedida.ultimaNegociacaoMes;

        if (exibirConfiguracoesAvancadas) {
          if (
            isNil(edicaoMedida.deflator) ||
            edicaoMedida.deflator === ID_OPCAO_DEFLATOR_NENHUM
          ) {
            return {
              ...medida,
              tipoAjuste: ajuste,
              ultimaNegociacao,
              ...analiseValorDaMedida(medida, state),
            };
          } else {
            return {
              ...medida,
              tipoAjuste: ajuste,
              deflator: edicaoMedida.deflator,
              valorBaseDeflator: edicaoMedida.valorBaseDeflator,
              valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
              dataBaseDeflator: edicaoMedida.dataBaseDeflator,
              ultimaNegociacao,
              dataBaseDeflatorDataEspecifica:
                edicaoMedida.dataBaseDeflatorDataEspecifica,
              ...analiseValorDaMedida(medida, state),
            };
          }
        } else {
          return {
            ...medida,
            tipoAjuste: ID_TIPO_AJUSTE_PRECO_PADRAO,
            ultimaNegociacao,
            ...analiseValorDaMedida(medida, state),
          };
        }
      })
    );
  }
);

const SeriesComAjusteEDeflator = () => {
  return (
    <>
      <SelecaoAjusteDePreco />
      <div className="ConfiguracaoMedida__vertical-divider" />
      <SelecaoDeflacao exibirLabelLegado={true} />
    </>
  );
};

export default SeriesComAjusteEDeflator;
